export const size = {
  xxSmall: 480,
  xSmall: 600,
  small: 768,
  medium: 1024
}

export const device = {
  xxSmall: `(max-width: ${size.xxSmall}px)`,
  xSmall: `(max-width: ${size.xSmall}px)`,
  small: `(max-width: ${size.small}px)`,
  medium: `(max-width: ${size.medium}px)`,
}



// WEBPACK FOOTER //
// ./src/lib/deviceSizes.js